export default {
  home: {
    minute: "minuto",
    hour: "hora",
    days: "días",
    price_info:
      "Los primeros {mianfei} minutos son gratis. El cargo máximo por 24 horas es {currencyName}{fengding}. Tu depósito {currencyName}{yajin} se reembolsará automáticamente tras devolver la batería externa",
    feature_1: "Incluye todos los tipos de cables: iPhone, Type‑C",
    feature_2: "Se puede devolver en cualquier estación",
    feature_3: "Carga inalámbrica disponible",
    tips_1:
      "Tu depósito {currencyName}{yajin} se devolverá al final del alquiler",
    tips_2:
      "El depósito recargable {currencyName}{yajin} se puede usar para el alquiler y, cuando se agote, se puede reembolsar",
    tips_3:
      "El saldo actual es {currencyName}{myyue}, se puede usar directamente para el alquiler",
    submit: "Iniciar alquiler",
    borrow: "Alquilar",
    msg_fail_title: "Error",
    msg_fail_content: "El alquiler falló, inténtalo de nuevo",
    msg_rentcount: "Tienes {zujieNum} pedidos que no están cerrados",
    goborrow: "¡Ir a cargar!",
    nearby: "Ver estaciones cercanas",
    preauth: "Preautorización"
  },
  login: {
    code_title: "Verificación por SMS",
    phone_number: "Número de teléfono",
    verification_code: "Introduce el código de verificación del SMS",
    captcha_code: "Código",
    send_code: "Enviar código",
    login: "Iniciar sesión",
    agree: "Al hacer clic en Iniciar sesión, aceptas ",
    readme: "el Acuerdo de Usuario",
    msg_fail_login: "Error al iniciar sesión",
    msg_success_login: "Inicio de sesión correcto",
    msg_fail_user:
      "Error al obtener la información del usuario. ¿Quieres reintentar?",
    sign_in_with: "Iniciar sesión con",
    no_sms: "No recibiste el SMS",
    retry: "Reenviar"
  },
  confirm: {
    deletecard: "Eliminar tarjeta",
    addcard: "Introduce los datos de la tarjeta",
    title: "Confirmación de pago",
    paynow: "Pago inmediato",
    SMSConfirm:
      "Por favor, paga según el mensaje recibido en tu teléfono y haz clic en confirmar para continuar.",
    pay_label: "Importe",
    auth_label: "Preautorización",
    price_tips:
      "Tu saldo se puede retirar si lo solicitas. Puede tardar de 1 a 5 días laborables en aparecer en tu cuenta de pago.",
    auth_tips:
      "Es obligatoria una preautorización de {0}{1}. El importe real del alquiler se deducirá al devolver la batería externa.",
    pay_type: "Selecciona tu método de pago preferido",
    submit: "Confirmar pago",
    msg_loading: "Cargando...",
    msg_fail_title: "Advertencia",
    msg_fail_payment: "No se pudo iniciar el pago del depósito",
    msg_fail_order: "No se pudo crear un pedido de alquiler",
    msg_fail_support: "El sistema no es compatible",
    msg_fail_confirm: "Confirmar",
    msg_fail_retry: "Reintentar",
    msg_fail_cancel: "Cancelar"
  },
  mine: {
    title: "Perfil de usuario",
    wallet: "Mi cartera",
    balance: "Mi saldo",
    deposit: "Depósito",
    wallet_in: "Recargar",
    wallet_out: "Retirar",
    wallet_log: "Historial de la cartera",
    rental_history: "Historial de alquileres",
    payment_title: "Métodos de pago",
    download_app: "Descargar la app",
    settings: "Ajustes",
    help: "Ayuda",
    logout: "Cerrar sesión",
    login_tips: "Por favor, inicia sesión",
    msg_fail_title: "Error",
    msg_fail_update: "La modificación falló. Inténtalo de nuevo",
    msg_loading: "Cargando...",
    msg_fail_user:
      "Error al obtener la información del usuario. ¿Quieres reintentar?",
    edit_profile: "Editar perfil",
    join_us: "ÚNETE A NOSOTROS",
    join_us_details: "Consigue una estación Cargamos en tu local"
  },
  msg: {
    appoffline: "La app aún no se ha lanzado, por favor espera",
    deletecard: "¿Seguro que quieres eliminar esta tarjeta?",
    no_phone: "Se requiere el número de teléfono",
    loading: "Cargando...",
    title: "Aviso",
    success: "Operación correcta",
    error: "Error desconocido. Inténtalo más tarde",
    roleerror: "Permisos insuficientes. Consulta con el administrador.",
    neterror: "Fallo de conexión de red. Inténtalo más tarde",
    confirm: "Confirmar",
    retry: "Reintentar",
    cancel: "Cancelar",
    title_fail: "Advertencia",
    vieworder: "Ver pedido",
    success_payment: "Pago completado",
    success_buy: "Compra completada",
    fail_payment: "Fallo de pago",
    keyword: "Palabra clave",
    ispayorder: "Confirma si el pago se ha realizado",
    unpay: "No pagado",
    yespay: "Pagado",
    notopen: "Aún no abierto"
  },
  result: {
    tips:
      "Para ver los pedidos y otras ubicaciones de estaciones, descarga la aplicación.",
    download: "Descargar la app",
    title: "Alquiler confirmado",
    gotit: "Entendido",
    price_plan: "Tarifa",
    msg_success: "Alquiler realizado con éxito",
    msg_tips_loading: "La batería externa está siendo expulsada, espera...",
    msg_result_loading: "Se está confirmando el resultado del pago...",
    msg_fail_confirm: "Confirmar",
    btn_usage: "Nota de uso",
    btn_return: "Nota de devolución",
    deposit: "Depósito",
    msg_fail_content: "La solicitud falló. Inténtalo de nuevo.",
    price_label: "por hora",
    price_info:
      "Los primeros {mianfei} minutos son gratis, el cargo diario máximo es {ccurrency}{fengding}. El depósito se deducirá automáticamente cuando el alquiler alcance {ccurrency}{yajin}",
    tips_1:
      "Por favor, recoge la batería externa n.º {number} como se muestra en la imagen",
    tips_2:
      "Por favor, organiza los cables e inserta la batería externa en la ranura con el lado marcado con [flechas hacia abajo]",
    msg_note_usage:
      "La batería externa cuenta con 3 tipos de cables, elige el que necesites para tu dispositivo.",
    msg_note_return:
      "Por favor, organiza los cables e inserta la batería externa en la ranura con el lado marcado con [flechas hacia abajo]",
    return_info:
      "Al devolverla, asegúrate de que los cables estén ordenados e inserta el lado con chips metálicos en una ranura disponible hasta el fondo.",
    download_tips:
      "Para alquilar nuestro powerbank, puedes elegir una de las siguientes opciones"
  },
  result_msg: {
    loading: "Cargando...",
    refresh: "Actualizar"
  },
  order: {
    title: "Historial de alquileres",
    in_use: "En uso",
    ended: "Finalizado",
    msg_error: "La solicitud falló",
    order_number: "N.º",
    order_details: "Detalles del pedido",
    order_zj_shop: "Lugar de alquiler",
    order_zj_time: "Hora de alquiler",
    order_gh_shop: "Lugar de devolución",
    order_gh_time: "Hora de devolución",
    order_use_time: "Tiempo de uso",
    order_amount: "Importe total",
    not_on_rent: "No en alquiler",
    renting: "En alquiler",
    undone: "No finalizado",
    returned: "Devuelto",
    questions: "Preguntas",
    timeout_to_return: "Tiempo excedido para devolución",
    suspended_for_billing: "Suspendido para facturación"
  },
  order_item: {
    order_number: "N.º",
    venue_rented: "Lugar de recogida",
    time_rented: "Hora de recogida",
    venue_returned: "Lugar de devolución",
    time_returned: "Hora de devolución",
    charge_standard: "Tarifa",
    charge_standard_info:
      "{pJifei} {pCurrency} por hora (primeros {pMian} min gratis)",
    rent_occurred: "Alquiler realizado",
    returned: "Devuelto",
    unreturned: "No devuelto",
    type_0: "No completado",
    type_1: "En alquiler",
    type_2: "Cancelado",
    type_3: "Devuelto",
    type_4: "Se produjo un error",
    type_5: "Horas extra",
    min: "min",
    payment: "Pago"
  },
  setting: {
    title: "Ajustes",
    lang: "Idioma"
  },
  help: {
    title: "Preguntas frecuentes",
    rentals: "Alquileres",
    venues: "Locales",
    payments: "Pagos"
  },
  wallet_in: {
    title: "Recarga de saldo",
    price_label: "Importe de recarga",
    price_placeholder: "Introduce el importe de recarga",
    balance: "Saldo actual",
    price_auto: "Elegir importe de pago",
    price_tips:
      "Tu saldo se puede retirar si lo solicitas. Puede tardar de 1 a 5 días laborables en aparecer en tu cuenta de pago.",
    submit: "Enviar",
    loading: "Cargando...",
    paying: "Redirigiendo a la página de pago...",
    msg_title: "Consejos",
    msg_fail_order: "No se pudo crear el pedido de recarga",
    msg_fail_payment: "No se pudo iniciar el pago de la recarga",
    msg_fail_retry: "Reintentar"
  },
  wallet_out: {
    title: "Retirada",
    price_label: "Importe de retirada",
    price_placeholder: "Introduce el importe de retirada",
    balance: "Saldo actual",
    balance_all: "Retirar todo",
    deposit: "Depósito",
    deposit_tips:
      "Hay un pedido de alquiler pendiente. El depósito de Ksh{pyajin} no es reembolsable",
    submit: "Enviar",
    apply: "Solicitar",
    confirm: "Confirmar",
    loading: "Cargando...",
    msg_fail_price: "El importe de retirada es incorrecto",
    msg_fail_balance: "El importe de retirada no puede superar el saldo actual",
    msg_fail_submit: "Por favor, completa toda la información requerida",
    msg_title: "Error",
    msg_success_content: "Reembolso correcto",
    confirmtitle: "Consejos",
    confirmcontent:
      "La cartera actual no admite retirada de efectivo. Por favor, deja tu información de contacto para el procesamiento manual del reembolso",
    payee_name: "Nombre del beneficiario",
    payee_bankcard: "Número de tarjeta bancaria",
    payee_phone: "Teléfono",
    cancelText: "Cancelar",
    confirmText: "Volver a solicitar"
  },
  map: {
    在线: "Abierto",
    离线: "Cerrado",
    title: "Estación cercana",
    result_msg: "No se encontró ninguna estación cercana",
    msg_title: "error",
    no_support: "¡Lo sentimos! Tu navegador no admite servicios de ubicación",
    my_position: "Mi ubicación",
    distance: "Distancia:",
    shop_time: "Horario",
    free: "Disponible para alquiler",
    return: "Ranuras vacías disponibles",
    shop_title: "Detalles del local",
    address: "Dirección",
    go_here: "Ir aquí",
    nav_help: "Ayuda",
    nav_search: "Buscar"
  },
  scanQr: {
    NotAllowedError: "Necesitas conceder acceso a la cámara",
    NotFoundError: "No hay cámara en este dispositivo",
    NotSupportedError: "Se requiere un contexto seguro (HTTPS, localhost)",
    NotReadableError: "La cámara está en uso",
    OverconstrainedError: "La configuración de la cámara no es adecuada",
    StreamApiNotSupportedError: "Este navegador no admite la API de streaming"
  },
  payment: {
    payment_title: "Métodos de pago",
    pay_type: "Añade los datos de tu tarjeta",
    add_payment_card: "Añadir tarjeta de pago",
    add_payment: "añadir pago"
  },
  shop: {
    title: "Estación cercana",
    search_station: "Buscar una estación",
    search_station_tips: "Introduce el nombre de la estación",
    shop_power_banks: "Baterías externas",
    shop_empty_slots: "Ranuras vacías",
    shop_address: "Dirección",
    shop_business_hours: "Horario",
    shop_directions_station: "Obtener indicaciones a la estación",
    shop_scan_qrcode: "Escanear QR"
  },
  paymethod: {
    payamount: "Importe a pagar",
    choosepaymethod: "Elegir opciones de pago",
    addcard: "Añadir nueva tarjeta",
    confrimpay: "Confirmar pago",
    借记卡: "Tarjeta de débito",
    银行卡列表: "Lista de tarjetas bancarias"
  },
  orderDetail: {
    price1: "{pJifei} {pCurrencyName} por {pJifeiDanwei} {priceUnit}",
    price2: "Hasta {pFengding} {pCurrencyName} por 24 horas",
    price3: "Tarifa por no devolución de {overtimeAmount} {pCurrencyName}",
    venuerented: "Lugar de alquiler",
    venuereturned: "Lugar de devolución",
    timerented: "Hora de alquiler",
    timereturned: "Hora de devolución",
    powerbankid: "ID de batería externa",
    getreceipt: "OBTENER RECIBO",
    buypowerbank: "Comprar este powerbank",
    usetime: "Tiempo de uso",
    estimatedamount: "Importe estimado",
    feerule: "Regla de tarifa",
    payment: "Pago",
    orderNo: "N.º de pedido",
    trafficDetails: "Ver detalles del tráfico del paquete",
    Renewals: "Renovaciones",
    FeeSchedule: "Tabla de tarifas",
    HowToUse: "Cómo usar",
    LeaseMerchant: "Arrendador",
    startTime: "Hora de inicio",
    ReturningMerchants: "Lugares de devolución",
    EndTime: "Hora de fin",
    Deposit: "Depósito",
    fee1: "Depósito del equipo {overtimeAmount} {pCurrencyName}",
    fee2:
      "Devuelto dentro de {overtime} días después de la fecha de vencimiento del alquiler, menos {pFengding} {pCurrencyName} por 24 horas.",
    fee3:
      "Si el equipo se devuelve dentro de {overtime} días después de que expire el período de alquiler, se deducirá {overtimeAmount} {pCurrencyName}.",
    fee4:
      "El depósito se deducirá automáticamente si el equipo no se devuelve más de 15 días después de la expiración de los días de alquiler.",
    rentagain: "Alquilar de nuevo",
    onrental: "En alquiler",
    revoked: "Revocado",
    returned: "Devuelto",
    issue: "Incidencia",
    overtimereturn: "Tiempo excedido"
  },
  selectpackage: {
    powerbank: "Batería externa",
    powerstation: "Estación",
    wifibox: "Caja Wi‑Fi",
    choosepackage: "Elegir un paquete de tráfico",
    minute: "minuto",
    首次免费: "Gratis los primeros ",
    最大每日收费: "Cargo diario máximo ",
    devicedeposit: "Depósito del equipo",
    return_will_back: "Devolver el depósito al retornar el equipo",
    lengthofuse: "Tiempo de uso",
    amountcharged: "Importe acumulado",
    release_powerbank: "Retira tu powerbank",
    see_pricing: "Ver precios",
    deposit: "depósito",
    agreen: "Al continuar, aceptas nuestra ",
    privacy_policy: "Política de privacidad",
    and: " y ",
    terms_and_conditions: "Términos y condiciones.",
    per: "por",
    tips_1: "El depósito de {yajin}{currencyName} será devuelto",
    tips_2:
      "Después de {pOvertimeDay} días se cobrará {overtimeAmount}{currencyName}"
  },
  rentcost: {
    rentcosttitle: "¿Cuánto cuesta el alquiler?",
    price1: "{jifei}{currency} por {jifeiDanwei} {priceUnit}",
    price2: "{fengding}{currency} por día",
    tip1:
      "Si no devuelves la batería externa dentro de {overtime} días, se te cobrará {overtimeAmount} {currency} y no necesitas devolverla.",
    tip2:
      "Un día de alquiler son 24 horas desde el momento en que se alquila la batería externa.",
    tip3:
      "Cobraremos {yajin}{currency} como depósito de seguridad, que se reembolsará una vez que la batería sea devuelta a la estación.",
    tip4:
      "Algunos locales pueden ofrecer horas gratis o descuentos. ¡Disfruta!",
    Days: "Días",
    Hours: "Horas",
    Minutes: "Minutos",
    free: "{mianfei} minutos gratis",
    willcharged: "Se te cobrará {currency} {money}"
  }
};
